import React from "react";
import "./Footer.css";
import { TextField } from "@mui/material";

const Footer = () => {
	const currentYear = new Date().getFullYear();
	return (
		<footer>
			<div className="FooterContainer">
				<div className="FooterLogo">
					<img
						src="https://res.cloudinary.com/dvczs0agl/image/upload/v1727719659/MONGO_LOGO-removebg-preview_ckskgg.png"
						alt="logo"
					/>
				</div>
				<div className="FooterContent">
					<div className="FooterItems">
						<h3>Get to Know Us</h3>
						<a href="">Careers</a>
						<a href="">Blog</a>
						<a href="">About Us</a>
						<a href="">Mongo Coffee Products</a>
						<a href="">Coffee Grades</a>
					</div>
					<div className="FooterItems">
						<h3>Let Us help You</h3>
						<a href="">Your Account</a>
						<a href="">Your Orders</a>
						<a href="">Shipping Rates & Policies</a>
						<a href="">Return & Replacements</a>
					</div>
					<div className="FooterItems">
						<h3>Payments</h3>
						<a href="">Powered by Pesapal</a>
						<a href="">Mpesa Supported</a>
						<a href="">Bank Payments Supported</a>
					</div>
					<div className="FooterItems">
						<h3>Mongo Coffee Support</h3>
						<a href="">Terms of Service</a>
						<a href="">Refund Policy</a>
						<a href="">Cookie Policy</a>
						<a href="">Privacy Policy</a>
						<a href="">Contact Us</a>
					</div>
				</div>
			</div>
			<div className="Developer">
				<div className="DeveloperContainer">
					<div className="RightsReserved">
						<p>© {currentYear} Mongo Coffee. All rights reserved.</p>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
